/**
 * CardStatusBadge — compact payment-readiness indicator for list views.
 *
 * Props
 *   cardOnFileStatus  'active' | 'needs_update' | anything else → "No Card"
 *   cardBrand         optional — shown when active (e.g. "Visa")
 *   cardLast4         optional — shown when active (e.g. "4242")
 */
import React from 'react';
import { CreditCard } from 'lucide-react';

const CardStatusBadge = ({ cardOnFileStatus, cardBrand, cardLast4 }) => {
  if (cardOnFileStatus === 'active') {
    const detail = cardBrand && cardLast4 ? `${cardBrand} ••••${cardLast4}` : 'Active';
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-green-100 text-green-700 border border-green-200 whitespace-nowrap"
        data-testid="card-status-active"
        title={`Card on file: ${detail}`}
      >
        <CreditCard className="h-2.5 w-2.5 shrink-0" />
        {detail}
      </span>
    );
  }

  if (cardOnFileStatus === 'needs_update') {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-amber-100 text-amber-700 border border-amber-200 whitespace-nowrap"
        data-testid="card-status-needs-update"
        title="Card on file needs updating"
      >
        <CreditCard className="h-2.5 w-2.5 shrink-0" />
        Needs Update
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 text-gray-400 border border-gray-200 whitespace-nowrap"
      data-testid="card-status-none"
      title="No card on file"
    >
      No Card
    </span>
  );
};

export default CardStatusBadge;
